import { useEffect } from 'react';
import {
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query';
import { toast } from '@/shared/hooks/use-toast';
import type { Pack } from '../types';
import { packApi } from '../api';
import { packKeys } from './pack.keys';

export function usePack(
  id?: string,
  options?: Omit<UseQueryOptions<Pack, Error>, 'queryKey' | 'queryFn'>
) {
  const queryKey = id ? packKeys.detail(id) : [...packKeys.details(), ''];
  const query = useQuery({
    queryKey,
    queryFn: ({ signal }) => {
      if (!id) throw new Error('ID do pack não informado');
      return packApi.get(id, signal);
    },
    enabled: Boolean(id),
    ...(options as Omit<UseQueryOptions<Pack, Error>, 'queryKey' | 'queryFn'>),
  });

  useEffect(() => {
    if (!query.error) return;
    toast({
      title: 'Erro ao carregar pack',
      description: query.error.message,
      variant: 'destructive',
    });
  }, [query.error]);

  return {
    pack: query.data ?? null,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
    refetch: query.refetch,
    queryResult: query,
  };
}
